module.exports = __webpack_public_path__ + "static/media/login.d71139b8.svg";